import React, { useState, useContext } from "react";
import { BreakpointContext } from "components/common";
import PageHeaders from "common/PageHeaders";
import Header from "components/Header";
import Menu from "common/Menu";
// import Email from "common/EmailTomoScore";
import TomoAIApp from "images/tomoAI_main.webp";
import TomoAIDesc from "images/tomoAI_desc.webp";
import TomoAILogo from "images/tomoAI_logo.svg";
import WaveBottom from "images/wave_bottom.svg";
import DoubleWave from "images/double_wave.svg";
import Star from "images/tomoAI_star.svg";
import EmailIcon from "../images/email-icon.svg";

const StarMark = ({ children }) => (
  <p className="flex whitespace-pre-wrap">
    <img src={Star} alt="" className="inline mr-3" style={{ width: 10, height: 10, marginTop: 7 }}/>
    <span>{children}</span>
  </p>
);

const AILandingPageBanner = () => {
  // const [bounce, setBounce] = useState(false);
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  // const bannerStyle =  { height: "calc(100vh - 80px)", minHeight: 700 };

  return (
    <div
      className="flex flex-col items-center text-black justify-center mx-auto"
      style={{ maxWidth: 1000 }}
    >
      <div
        className={`flex justify-center items-center ${
          belowMd ? "flex-col-reverse py-10" : "flex-row py-20"
        }`}
      >
        <div className="p-10 lg flex flex-col items-start">
          <div>
            <span
              style={{
                backgroundColor: "#B6F6E8",
                paddingRight: 10,
                paddingLeft: 10,
              }}
              className="text-black text-center font-gilroy font-bold mr-2 py-0.5"
            >
              NEW!
            </span>
            {/* <h1 className="text-5xl font-extrabold flex">
              tomo
              <span className="text-boost-primary-500">AI</span>
              .
            </h1> */}
            <img alt="tomoAI" src={TomoAILogo} />
            <h2 className="my-4 text-xl">
              <span className="font-bold">AI-Powered</span> Credit Assistant
            </h2>
          </div>
          <div className={`my-5 space-y-2 ${belowMd ? "text-sm" : "text-md"}`}>
            <StarMark>End-to-end credit building solution.</StarMark>
            <StarMark>
              Approve cash-rich borrowers{" "}
              <span className="font-bold">risk free.</span>
            </StarMark>
            <StarMark>
              Proven performance data of the &quot;credit-invisible&quot; who
              have high income.
            </StarMark>
          </div>
          {/* kyle: skipping email collection in v1 */}
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          {/* <div className="w-full mt-5 flex flex-col lg:flex-row gap-x-4 gap-y-10">
            <Email
              text="Get in touch"
              belowMd={belowMd}
              handleSubmit={() => {}}
              componentClassName="flex-col md:flex-row space-y-2 md:space-y-0"
              inputClassName="w-full rounded-md md:rounded-r-none border border-neutral-500 md:border-r-0"
              buttonClassName="w-full md:w-auto rounded-md md:rounded-l-none border border-boost-primary-500"
            />
          </div> */}
        </div>
        <div
          className="lg:ml-10"
          style={{
            minWidth: belowMd ? 250 : 320,
            maxWidth: belowMd ? 250 : 500,
          }}
        >
          <img src={TomoAIApp} alt="tomo" className="w-full h-auto" />
        </div>
      </div>
    </div>
  );
};

const AILandingPageContent = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  // const bannerStyle =  { height: "calc(100vh - 80px)", minHeight: 700 };

  return (
    <div
      className="mt-20 px-6 flex flex-col items-center text-black justify-center mx-auto"
      style={{ maxWidth: 1000 }}
    >
      <div className="flex flex-col md:flex-row justify-center items-center">
        <div
          className="md:mr-20"
          style={{
            minWidth: belowMd ? 250 : 400,
            maxWidth: belowMd ? undefined : 500,
          }}
        >
          <img src={TomoAIDesc} alt="tomo" className="w-full h-auto" />
        </div>
        <div style={{ maxWidth: 463 }}>
          <div className="text-4xl font-bold mt-10" style={{ lineHeight: 1.2 }}>
            <div>Decrease Losses,</div>
            <div>Grow Approvals</div>
          </div>
          <p className="mt-5">
            TomoScore is a modern, cash flow-based credit score that provides a
            risk-free method for businesses to evaluate the creditworthiness of
            high-quality borrowers who lack a traditional credit score.
          </p>
          <br />
          <p>
            Our key customer profiles characteristics are:{" "}
            <span className="font-bold">upwardly mobile, highly educated,</span>{" "}
            and <span className="font-bold">cash rich</span> users who are
            credit-invisible.
          </p>
        </div>
      </div>
      <div className="my-20 px-5 flex flex-col items-center">
        <img src={DoubleWave} alt="" className="mb-3" />
        <div className="font-bold italic text-4xl">
          “TomoScore is the currency for modern banking.”
        </div>
      </div>
    </div>
  );
};

const AILandingPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <PageHeaders type="ai" />
      <div className="flex flex-col h-full w-full">
        <div className={`relative ${menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={(state) => {
              setMenuOpen(!!state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="">
          <div className="headerBar fixed">
            <Header />
          </div>
          <div className="pt-16" style={{ backgroundColor: "#F4F3F6" }}>
            <AILandingPageBanner />
            <img src={WaveBottom} alt="" className="w-full bg-white" />
          </div>
          <AILandingPageContent />
          <div className="mx-auto bg-neutral-600 flex flex-col md:flex-row justify-center items-start py-10 px-5 md:px-20">
            <div className="whitespace-nowrap">
              <div className="font-bold">Want to learn more?</div>
              <div>We are eager to connect with you.</div>
            </div>
            {/* kyle: skipping email collection in v1 */}
            <div className="flex mt-5 md:ml-10 md:mt-0">
              <a href="mailto:sales@tomocredit.com">
                <img src={EmailIcon} alt="" className="inline mr-2" />
                <span className="hover:underline">sales@tomocredit.com</span>
              </a>
            </div>
            {/* <div className="w-full flex justify-center items-center mt-5 md:ml-10 md:mt-0" style={{ maxWidth: 620 }}>
              <Email
                handleSubmit={() => {}}
                componentClassName="flex-row"
                inputClassName="rounded-md rounded-r-none border border-neutral-500 md:border-r-0"
                buttonClassName="rounded-md rounded-l-none border border-boost-primary-500"
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AILandingPage;
